import React from 'react';
import { Skeleton, Box } from '@mui/material';

const AccionesSkeleton = () => {
    // Número de filas del skeleton a mostrar
    const skeletonRows = 10;

    return (
        <Box>
            {/* Filas de la tabla */}
            {Array.from({ length: skeletonRows }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1.5fr 1fr 2fr 1fr',
                        gap: 2,
                        px: 3,
                        py: 2.5,
                        borderBottom: index < skeletonRows - 1 ? '1px solid #f0f0f0' : 'none',
                        alignItems: 'center',
                    }}
                >
                    {/* Columna: Funcionario */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Skeleton variant="text" width="80%" height={20} />
                    </Box>

                    {/* Columna: Acción */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Skeleton variant="text" width="70%" height={20} />
                    </Box>

                    {/* Columna: Detalles */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Skeleton variant="text" width="90%" height={20} />
                    </Box>

                    {/* Columna: Fecha */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Skeleton variant="text" width="75%" height={20} />
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default AccionesSkeleton;
